"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqual = void 0;
var isEqual = function (currentValue, oldValue) {
    if (Array.isArray(currentValue)) {
        return !Array.isArray(oldValue)
            ? false
            : JSON.stringify(currentValue.sort()) === JSON.stringify(oldValue.sort());
    }
    return currentValue === oldValue;
};
exports.isEqual = isEqual;
//# sourceMappingURL=valueComparator.js.map